import SafeUncontrolledPopover from 'components/SafeUncontrolledPopover';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';

interface Props {
  iconStyle?: React.CSSProperties;
}

const NetworkRecognitionInProgress: FC<Props> = ({ iconStyle }) => {
  return (
    <span className="ms-3">
      <span className="text-uppercase badge rounded-pill fs-6 bg-warning">
        <FormattedMessage
          id="app.views.person.person_performance.trajectory.trajectory_summary.phase_is_still_in_progress"
          defaultMessage="Phase still in progress"
        />
      </span>
      <i
        className="fe fe-help-circle text-primary fs-5 position-relative ms-2"
        id="phase-network-still-in-progress-text"
        style={iconStyle}
      />
      <SafeUncontrolledPopover
        trigger="hover"
        placement="top"
        target="phase-network-still-in-progress-text"
      >
        <FormattedMessage
          id="app.views.person.person_performance.trajectory.trajectory_summary.popover.phase_network_still_in_progress_text"
          defaultMessage="The network recognition data is based on feedback received from colleagues during this cycle. As more feedback is submitted, these numbers may change."
        />
      </SafeUncontrolledPopover>
    </span>
  );
};
export default React.memo(NetworkRecognitionInProgress);
